import Image from 'next/image'
import { useState } from 'react'
import { useVideoScale } from '../useVideoScale'

type Props = {
  onClick: () => void
}

export const BackButton = ({ onClick }: Props) => {
  const [hover, setHover] = useState(false)
  const { videoScale } = useVideoScale()

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        transition: 'all 0.2s cubic-bezier(0.3, 0.3, 0.3, 1)',
        color: 'white',
        textShadow: '0 0 2px rgba(0, 0, 0, .5)',
        opacity: hover ? 0.86 : 0.7,
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '4px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Image src='/player/back.png' alt='Back' width={videoScale * 48} height={videoScale * 48} />
    </button>
  )
}
